<template>
  <div :class="classes">
    <div class="row">
      <div class="col-12 col-md-7 imageWrap">
        <Image v-bind="$props" />
        <VideoDialog v-if="videoDialog" v-bind="videoDialog" />
      </div>
      <div class="col-12 col-md-5 d-flex flex-column justify-content-center">
        <TextBlock
          :first-button-content="firstButtonContent"
          :first-button-file-name="firstButtonFileName"
          :first-button-in-new-window="firstButtonInNewWindow"
          :first-button-url="firstButtonUrl"
          :second-button-content="secondButtonContent"
          :second-button-file-name="secondButtonFileName"
          :second-button-in-new-window="secondButtonInNewWindow"
          :second-button-url="secondButtonUrl"
        >
          <div v-html="bodyText" />
        </TextBlock>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import './MediaBlock.scss';
import Image, { type ImageProps } from 'ewi-ui/components/1-atoms/Media/Image';
import TextBlock from 'ewi-ui/components/2-molecules/TextBlock';
import { computed } from 'vue';
import VideoDialog, {
  type VideoDialogProps,
} from 'ewi-ui/components/2-molecules/VideoDialog';

export interface MediaBlockProps extends ImageProps {
  background?: string;
  bodyText?: string;
  firstButtonContent?: string;
  firstButtonFileName?: string;
  firstButtonInNewWindow?: boolean;
  firstButtonUrl?: string;
  secondButtonContent?: string;
  secondButtonFileName?: string;
  secondButtonInNewWindow?: boolean;
  secondButtonUrl?: string;
  imagePosition?: string;
  videoDialog?: VideoDialogProps;
}

const props = withDefaults(defineProps<MediaBlockProps>(), {
  background: 'lightgrey',
  bodyText: '',
  firstButtonContent: '',
  firstButtonFileName: '',
  firstButtonInNewWindow: false,
  firstButtonUrl: '#',
  secondButtonContent: '',
  secondButtonFileName: '',
  secondButtonInNewWindow: false,
  secondButtonUrl: '#',
  imagePosition: 'left',
  videoDialog: undefined,
});

const classes = computed(() => ({
  'm-media-block': true,
  [`bg-${props.background}`]: props.background !== '',
  [`image-position-${props.imagePosition}`]: props.imagePosition !== '',
}));
</script>
